import { gasNonServiceablePostcodes } from '@energy-retailer/constants';

const VALIDATE_GAS_POSTCODE = true;

export const getIsGasAvailable = (
  state: string,
  postcode?: string,
  hasGasDistributors?: boolean
): boolean => {
  if (state !== 'NSW' && state !== 'VIC') {
    return false;
  }

  if (!postcode) {
    return false;
  }

  if (!hasGasDistributors) {
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- hardcode for now
  if (!VALIDATE_GAS_POSTCODE) {
    return true;
  }

  if (!gasNonServiceablePostcodes.includes(Number(postcode))) {
    return true;
  }

  return false;
};
